<template>
	<div class="healthpage flexCloumnSingleCenter">
		<div class="form">
			<div class="cell-group-title flexStart">
				<span style="color: #1283FF">*</span>基本信息
			</div>
			<div class="cell-group">
				<van-field :readonly="disabled" v-model="editForm.department" label="系部" required placeholder="请输入系部">
				</van-field>
				<van-field :readonly="disabled" v-model="editForm.class" label="班级" required placeholder="请输入班级">
				</van-field>
				<van-field :readonly="disabled" v-model="editForm.stuName" label="姓名" required placeholder="请输入姓名" />
				<van-field :readonly="disabled" class="childBox" name="checkbox" label="性别" required>
					<template #input>
						<van-radio-group :disabled="disabled" :readonly="disabled" v-model="editForm.gender"
							direction="horizontal">
							<van-radio name="1">男</van-radio>
							<van-radio name="2">女</van-radio>
						</van-radio-group>
					</template>
				</van-field>
			</div>

			<div v-if="false" class="cell-group-title flexStart">
				<span style="color: #1283FF">*</span>父母等家庭成员信息
			</div>
			<div v-if="false" class="cell-group">
				<van-field :readonly="disabled" v-model="editForm.parentName" label="姓名" required
					placeholder="请输入一个家庭成员姓名" />
				<van-field :readonly="disabled" v-model="editForm.workplace" label="工作单位" required
					placeholder="请输入工作单位" />
				<van-field :readonly="disabled" v-model="editForm.phone1" label="电话" required placeholder="请输入手机号" />
				<van-field label-width='7em' :readonly="disabled" v-model="editForm.phone2" label="其他联系方式：" required
					placeholder="请输入手机号" />
			</div>

			<div class="cell-group-title flexStart">
				<span style="color: #1283FF">*</span>家长信息
			</div>
			<div class="cell-group">
				<van-field :readonly="disabled" v-model="editForm.parentName1" label="家长1姓名" required
					placeholder="请输入家长姓名" />
				<van-field :readonly="disabled" v-model="editForm.workplace1" label="工作单位" required
					placeholder="请输入工作单位" />
				<van-field :readonly="disabled" v-model="editForm.phone1" label="联系电话" type="tel" required
					placeholder="请输入手机号" />
				<van-field :readonly="disabled" v-model="editForm.parentName2" label="家长2姓名" placeholder="请输入家长姓名" />
				<van-field :readonly="disabled" v-model="editForm.workplace2" label="工作单位" placeholder="请输入工作单位" />
				<van-field :readonly="disabled" v-model="editForm.phone2" label="联系电话" type="tel"
					placeholder="请输入手机号" />
			</div>


			<div class="cell-group" style="margin-top: 10px;">
				<div class="flexStart" style="padding-top: 10px;">
					身体健康状况<span style="font-size: 12px;color: #aaa;">（有以下情况点击勾选）</span>
				</div>
				<div style="padding: 10px 16px;border-bottom: 0.5px solid #ebedf0;">
					<van-checkbox-group :disabled="disabled" :readonly="disabled" direction="horizontal"
						v-model="editForm.diseaseChecked">

						<van-checkbox v-for="(item,index) in editForm.diseases" :key="index" :name="item"
							shape="square">{{ item }}
						</van-checkbox>
						<span class="van-checkbox flexStart">
							<i class="el-icon-edit" @click="onEditOther">其他疾病</i>
						</span>
					</van-checkbox-group>
				</div>
				<div class="flexCloumn" style="width: 100%;">
					<div class="item-title flexStart">既往病史简述</div>
					<div class="item-input" style="border-bottom: 0.5px solid #ebedf0;">
						<el-input :disabled="disabled" v-model.trim="editForm.remark1" type="textarea"
							placeholder="请输入内容……" :autosize="{ minRows: 4, maxRows: 10 }" style="width: 100%" />
					</div>
				</div>
				<div class="flexCloumn" style="width: 100%;">
					<div class="item-title" style="border-bottom: 0.5px solid #ebedf0;">
						能否正常上体育课、进行体育竞赛、跑步、跳舞等剧烈 运动（活动）

						<van-radio-group :disabled="disabled" :readonly="disabled" v-model="editForm.attendPEclass"
							direction="horizontal">
							<van-radio name="1">能</van-radio>
							<van-radio name="0">不能</van-radio>
						</van-radio-group>
					</div>
				</div>

				<div class="flexCloumn" style="width: 100%;">
					<div class="item-title flexStart">其他需要说明的问题</div>
					<div class="item-input" style="border-bottom: 0.5px solid #ebedf0;">
						<el-input :disabled="disabled" v-model.trim="editForm.remark2" type="textarea"
							placeholder="请输入内容……" :autosize="{ minRows: 4, maxRows: 10 }" style="width: 100%" />
					</div>
				</div>

				<div style="width: 100%;">
					<div class="item-title flexStart" style="border-bottom: 0.5px solid #ebedf0;">
						<div style="font-weight: 700;">以上情况真实有效</div>
						<van-checkbox :disabled="disabled" v-model="editForm.isConfirm" shape="square"
							style="margin: 0 0 0 10px;"></van-checkbox>
					</div>
				</div>

				<div class="flexCloumn" style="width: 100%;">
					<div class="item-title flexStart">
						<span style="color: #1283FF">*</span>
						<span class="flexCenter">家长签名</span>
						<el-tag v-if="!disabled" size="small" @click="goSign" class="signBtn">
							{{ !editForm.signUrl ? '前往签名' : '修改签名' }}
						</el-tag>
					</div>
					<div class="signUrl-box">
						<img :src="editForm.signUrl" mode="aspectFit"></img>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!disabled" class="submitBtn flexCenter" style="background-color:#fff;">
			<div class="btn btnChange" @click="onSubmitForm">确定</div>
		</div>
		<div v-if="disabled" class="submitBtn flexCenter" style="background-color:#fff;">
			<div class="btn" @click="onModify">点击修改</div>
		</div>
		<div style="width: 100%;height: 100px;background-color:#fff;"></div>

		<!--    编辑其他疾病-->
		<vanDialog v-model="showOther" title="其他疾病" show-cancel-button confirm-button-color="#1283ff" :before-close="(action, done)=>{
                addOther(action, done)
              }">
			<div style="margin: 16px;padding:0 2px;border: 1px solid #1283FF;border-radius: 6px;">
				<van-field :readonly="disabled" v-model="editForm.otherText" label="" placeholder="请填写其他疾病" />
			</div>

		</vanDialog>

		<!-- <van-dialog v-model="showOther" title="标题" show-cancel-button>
		  <img src="https://img01.yzcdn.cn/vant/apple-3.jpg" />
		</van-dialog> -->

		<div v-if="showhandsign"
			style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);">
			<handSign @returnImg="getHandSign"></handSign>
		</div>
	</div>
</template>

<script>
	import {
		Toast,
		Dialog
	} from 'vant';
	import wx from 'weixin-js-sdk'
	import handSign from "../../../com/handSign.vue"
	export default {
		components: {
			"vanDialog": Dialog.Component,
			handSign
		},
		// props: {
		//   tableInfo: {
		//     type:Object,
		//     default:{}
		//   },
		//   signUrl: {
		//     type:String,
		//     default:''
		//   },
		//   stu_id:{
		//     type:Number,
		//     default:0
		//   },
		//   pmid: {
		//     type:Number,
		//     default:5
		//   },
		// },
		data() {
			return {
				editForm: {
					department: '',
					class: '',
					stuName: '',
					gender: '1',

					parentName1: '',
					workplace1: '',
					phone1: '',
					parentName2: '',
					workplace2: '',
					phone2: '',

					idNumber: '',
					// parentName: '',
					// workplace: '',
					// phone1: '',//13333333333
					// phone2: '',
					diseases: ['心脏疾病', '血液病', '肾炎', '支气管哮喘', '癫痫病', '过敏性疾病', '癔病', '肺结核病', '肝炎', '心理原因', ],
					diseaseChecked: [],
					remark1: '',
					attendPEclass: "1",
					remark2: '',
					isConfirm: false,
					signUrl: '',
				},
				showOther: false,
				openid: null,
				disabled: false,
				pmid: 5,
				stu_id: 0,
				signUrl: '',
				tableInfo: {},
				showhandsign: false,

			}
		},
		mounted() {
			// console.log('wx',wx)
			let _this = this
			$(".healthpage").height($(window).height()) //设置页面高度固定，防止输入法弹出页面变形，注意内部元素不能使用vh

			if (this.$route.query) {
				console.log(79, this.$route.query)
				this.stu_id = Number(this.$route.query.stu_id)
				this.pmid = Number(this.$route.query.pmid)
				if (this.$route.query.signurl) {
					this.asyncLocalStorage.getItem('editForm').then(r => {
						let editForm = localStorage.getItem('editForm')
						if (editForm) {
							editForm = JSON.parse(editForm)
							//转Boolean
							if (editForm.isConfirmStu == 'true') {
								editForm.isConfirmStu = true
							}
							if (editForm.isConfirmParent == 'true') {
								editForm.isConfirmParent = true
							}
							if (editForm.isConfirmStu == 'false') {
								editForm.isConfirmStu = false
							}
							if (editForm.isConfirmParent == 'false') {
								editForm.isConfirmParent = false
							}
							_this.editForm = {
								...editForm
							}
							console.log(1, this.$route.query.signurl)
							_this.editForm.signUrl = decodeURIComponent(_this.$route.query.signurl)
							this.editForm = {
								..._this.editForm
							}
							console.log(162, _this.editForm)
						}
					})
				} else {
					_this.getList(1)
				}

			}


			return


			if (this.$route.params && this.$route.params.item) {
				this.tableInfo = this.$route.params.item
				document.title = this.$route.params.item.table_name
				this.stu_id = Number(this.$route.params.stu_id)
				this.pmid = Number(this.$route.params.pmid)
			} else if (this.$route.query) {
				console.log(79, this.$route.query)
				this.stu_id = Number(this.$route.query.stu_id)
				this.pmid = Number(this.$route.query.pmid)
				if (_this.$route.query.signurl) {
					_this.signUrl = decodeURIComponent(_this.$route.query.signurl)
					console.log(102, _this.signUrl)
				}
			}

			console.log(_this.signUrl, _this.signUrl != '' && _this.signUrl != null)
			if (_this.signUrl) {
				this.asyncLocalStorage.getItem('editForm').then(r => {
					let editForm = localStorage.getItem('editForm')
					if (editForm) {
						editForm = JSON.parse(editForm)
						_this.editForm = {
							...editForm
						}
						_this.editForm.signUrl = _this.signUrl
						this.editForm = {
							..._this.editForm
						}
						console.log(195, _this.editForm)
					}
				})
			} else {
				this.asyncLocalStorage.getItem('tableInfo').then(r => {
					let tableInfo = localStorage.getItem('tableInfo')
					tableInfo = JSON.parse(tableInfo)
					if (tableInfo.table_detail) {
						this.disabled = true
						let detail = JSON.parse(tableInfo.table_detail)
						_this.editForm = Object.assign(detail)
					}
					_this.editForm.stuName = tableInfo.stu_name
					_this.editForm = {
						..._this.editForm
					}
					console.log(_this.editForm)

				})
			}
		},
		methods: {
			getStuInfo() {
				let _this = this
				return new Promise(resolve => {
					this.$http.post("/api/stu_luqu_detail", {
						stu_id: _this.stu_id,
						pmid: this.pmid
					}).then(res => {
						console.log(res.data)
						if (res.data) {
							_this.editForm.department = res.data.yuanxi_name
							_this.editForm.major_name = res.data.major_name
							_this.editForm.class = res.data.class_name
							_this.editForm.stuName = res.data.stu_name
							_this.editForm.gender = String(res.data.gender)
							_this.editForm.idNumber = res.data.identity_card

							_this.editForm = {
								..._this.editForm
							}
							console.log(_this.editForm)
						}
						resolve()
					})
				})
			},

			getList(flag) {
				let _this = this
				return new Promise(resolve => {
					this.$http.post('/api/t_stu_check_in_table_list', {
						pmid: _this.pmid,
						stu_id: _this.stu_id
					}).then(res => {
						for (let item of res.data.data) {
							if (item.table_name.indexOf('身体状况') != -1) {
								document.title = item.table_name
								_this.tableInfo = item

								if (flag == 1) {
									if (item.table_detail) {
										let detail = JSON.parse(item.table_detail)
										//转Boolean
										if (detail.isConfirm == 'true') {
											detail.isConfirm = true
										}
										if (detail.isConfirm == 'false') {
											detail.isConfirm = false
										}
										_this.editForm = Object.assign(detail)
										_this.disabled = true
									} else {
										_this.getStuInfo().then(r => {
											_this.$http.post('/api/t_stu_check_in_table_list', {
												pmid: _this.pmid,
												stu_id: _this.stu_id
											}).then(res => {
												for (let item of res.data.data) {
													if (item.table_name.indexOf('学生信息') !=
														-1) {
														if (item.table_detail) {
															let info = JSON.parse(item
																.table_detail)
															_this.editForm.parentName1 =
																info.parentName1
															_this.editForm.workplace1 =
																info.workplace1
															_this.editForm.phone1 = info
																.phone1
															_this.editForm.parentName2 =
																info.parentName2
															_this.editForm.workplace2 =
																info.workplace2
															_this.editForm.phone2 = info
																.phone2

															_this.editForm = {
																..._this.editForm
															}
														}
														break
													}
												}
											})
										})

										_this.disabled = false
									}
								}
								console.log(_this.editForm)
								resolve()
								return;
							}
						}
						resolve()
					})
				})

			},

			onEditOther() {
				if (!this.disabled) {
					this.showOther = true
					this.editForm.otherText = ''
				}
			},
			addOther(action, done) {
				if (action == 'confirm' && this.editForm.otherText) {
					this.editForm.diseases.push(this.editForm.otherText)
					this.showOther = false
				}
				done()
			},
			checkPhone(v) {
				let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
				if (strTemp.test(v)) {
					return true;
				}
				return false;
			},
			onSubmitForm() {
				let _this = this
				console.log(this.editForm)
				if (!this.editForm.department || !this.editForm.class || !this.editForm.stuName || !this.editForm.gender) {
					Toast('请将基本信息填写完整！');
					return
				}

				if (!this.editForm.parentName1 || !this.editForm.workplace1 || !this.editForm.phone1) {
					Toast('请将家长信息必填项填写完整！');
					return
				}
				if (this.editForm.phone1 && !_this.checkPhone(this.editForm.phone1)) {
					Toast('家长1联系电话为手机号，输入格式不正确！');
					return
				}
				if (this.editForm.phone2 && !_this.checkPhone(this.editForm.phone2)) {
					Toast('家长2联系电话为手机号，输入格式不正确！');
					return
				}

				if (!this.editForm.signUrl) {
					Toast('家长签名不能为空！');
					return
				}
				if (!_this.editForm.isConfirm) {
					Dialog.alert({
						title: "请确保以上情况真实有效",
						showCancelButton: true,
						confirmButtonText: "确保真实有效",
						cancelButtonText: "关闭",
						confirmButtonColor: '#1283FF',
					}).then(() => {
						_this.editForm.isConfirm = true
					}).catch(() => {
						console.log("点击了取消按钮噢")
					})
				} else {
					_this.getList(0).then(result => {
						console.log(_this.tableInfo)
						let params = {}
						params.table_detail = JSON.stringify(_this.editForm)
						params.table_name = _this.tableInfo.table_name
						params.table_code = _this.tableInfo.table_code
						params.stu_id = this.stu_id
						params.table_type_id = _this.tableInfo.type_id
						params.pmid = this.pmid
						if (_this.tableInfo.id) {
							params.id = _this.tableInfo.id
						}
						console.log(params)
						this.requestForm(params)
					})
				}
			},
			requestForm(params) {
				let _this = this
				this.$http.post("/api/t_stu_check_in_table_edit", params).then(function(res) {
					if (res.data.id || res.data.message == '') {
						Toast('保存成功！')
						localStorage.removeItem('tableInfo')
						localStorage.removeItem('editForm')
						setTimeout(function() {
							_this.editForm = {}
							wx.miniProgram.navigateBack({
								delta: 1
							})
						}, 500)
            _this.preExport()
					} else {
						Toast(res.data.msg)
						_this.disabled = false
					}
				})

			},
      preExport() {
        let _this = this
        this.$http.post("/api/stu_luqu_detail", {
          stu_id: _this.stu_id,
          pmid: _this.pmid
        }).then(res => {
          console.log(res.data)
          if (res.data.class_id) {
            let params = {
              class_id: _this.editForm.class_id,
              stu_ids: _this.stu_id,
              pmid: _this.pmid,
            }
            _this.$http.post("/api/exportWord1", params).then(function (res) {})
          }

        })


      },


      goSign() {
				this.showhandsign = true

				return
				this.asyncLocalStorage.setItem('editForm', JSON.stringify(this.editForm)).then(r => {
					console.log('localStorage editForm', localStorage.getItem('editForm'))
					wx.miniProgram.navigateTo({
						url: '/pages/handsign/handsign?from=h5health'
					})
				})
			},

			getHandSign(e) {
				console.log(e)

				this.showhandsign = false
				if (e) {
					this.$http.post("/api/save_base64_img", {
						base64_img: e
					}).then(res => {
						this.editForm.signUrl = res.data.url
					})
				}

			},

			onModify() {
				let curTime = new Date().getTime()
				let time1 = new Date(this.tableInfo.cdate).getTime()
				let val = curTime - time1
				this.getDuration(val).then(result => {
					console.log(result.d, result.h)
					if (result.d > 0 || result.h > 3) {
						this.disabled = false
					} else {
						Dialog.alert({
							title: "距上次提交时间小于3小时，请不要频繁修改。",
							showCancelButton: false,
							confirmButtonText: "确定",
							cancelButtonText: "关闭",
							confirmButtonColor: '#1283FF',
						}).then(() => {
							this.disabled = true
						}).catch(() => {
							console.log("点击了取消按钮噢")
						})
					}
				})
				console.log(new Date(), this.tableInfo.cdate, this.tableInfo)
			},
			getDuration(my_time) {
				return new Promise(resolve => {
					var days = my_time / 1000 / 60 / 60 / 24;
					var daysRound = Math.floor(days);
					var hours = my_time / 1000 / 60 / 60 - (24 * daysRound);
					var hoursRound = Math.floor(hours);
					var minutes = my_time / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound);
					var minutesRound = Math.floor(minutes);
					var seconds = my_time / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 *
						minutesRound);
					console.log('转换时间:', daysRound + '天', hoursRound + '时', minutesRound + '分', seconds + '秒');
					var time = hoursRound + ':' + minutesRound + ':' + seconds
					let obj = {
						d: daysRound,
						h: hoursRound
					}
					resolve(obj)
					return time;
				})

			},
		},
	}
</script>

<style lang="less" type="text/less">
	.el-textarea__inner:focus {
  outline: 0;
  border-color: #1283FF !important;
}

.van-radio__icon {
  font-size: 16px;
}

.van-radio__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-checkbox {
  margin-top: 10px;
}

.van-checkbox__icon {
  font-size: 16px;
}

.van-checkbox__icon--checked .van-icon {
  background-color: #1283FF;
  border-color: #1283FF;
}

.van-tag--primary {
  background-color: #1283FF;
}

.van-cell--required::before {
  color: #1283FF !important;
}

.healthpage {
  display: block;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-color: #f5f5f5;

  .form {
    flex: 1;
    width: 100%;
    box-sizing: border-box;

    div {
      font-size: 14px;
      color: #323232;
      box-sizing: border-box;
    }

    .cell-group-title {
      margin: 10px 0 5px 15px;
      font-size: 14px;
      color: #969799;
    }

    .cell-group {
      padding: 0 20px;
      background-color: #fff;
    }

    .topInfo {
      color: #00D1CB;
      font-size: 12px;
    }

    .item-title {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 16px;
    }

    .item-input {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 0 16px 10px 16px;
      font-size: 14px;
      color: #646566;
    }

    .item-input1 {
      color: #ee0a24;
      font-size: 12px;
      line-height: 18px;
    }

    .item-input1::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 16px;
      bottom: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
    }

    .signUrl-box {
      margin-top: 10px;
      border: 1px solid #EEF2F5;
      width: 100%;
      height: 150px;
      padding: 10px;
    }

    .signUrl-box img {
      display: inline-block;
      max-width: 100%;
      max-height: 100%;
    }

    .signBtn {
      margin-left: 10px !important;
      margin-top: 1px;
    }
  }

  .submitBtn {
    padding-top: 6vh;
    width: 100%;

    .btn {
      display: inline-block;
      padding: 1.4vh 0;
      width: 60%;
      text-align: center;
      background-color: #1283FF;
      color: #fff;
      font-size: 15px;
      border-radius: 6px;
    }
  }
}

</style>
